import React from "react";
import { twMerge } from "tailwind-merge";

export function SellarStepper({
  steps,
  activeStep,
  className,
}: {
  steps: number;
  activeStep: number;
  className?: string;
}) {
  const stepsArray = Array.from(Array(steps).keys());
  return (
    <div className={twMerge("flex h-1 gap-1 bg-white", className)}>
      {stepsArray.map((step: number, index: number) => (
        <div
          key={step}
          className={twMerge(
            "grow rounded-xs bg-gray-200",
            index < activeStep && "bg-gray-700",
          )}
        />
      ))}{" "}
    </div>
  );
}
